<div>
  <ng-container *ngIf="storages$ | async; let storages; else loadingOptions">
    <fw-form-heading *ngIf="title || description" [title]="title" [description]="description"></fw-form-heading>
    <fw-select [disabled]="isDisabled" [value]="currentValue" width="100%" [maxOptionsHeight]="maxOptionsHeight"
      [optionsWidth]="optionsWidth" [showFilter]="true" (filterChanged)="filterChange($event)"
      (change)="onStorageSelect($event, storages)" [placeholder]="placeholder">
      <fw-menu-item *ngFor="let storage of extraOptions" [value]="storage._id"
        [hidden]="!visibleExtraOptionsSet.has(storage)" [title]="storage.label | translate"
        [description]="storage.url | translate"></fw-menu-item>
      <fw-menu-separator *ngIf="visibleExtraOptionsSet.size"></fw-menu-separator>
      <fw-menu-item *ngFor="let storage of storages" [value]="storage._id" [title]="storage.label"
        [hidden]="!visibleOptionsSet.has(storage)" [description]="storage.url"></fw-menu-item>
      <fw-menu-item *ngIf="!visibleExtraOptionsSet.size && !visibleOptionsSet.size"
        [title]="'common.labels.noResults' | translate" [disabled]="true"></fw-menu-item>
    </fw-select>
  </ng-container>
  <ng-template #loadingOptions>
    <fw-form-heading *ngIf="title || description" [title]="title" [description]="description"></fw-form-heading>
    <fw-select width="100%" [disabled]="true" [placeholder]="placeholder"></fw-select>
  </ng-template>
</div>
